import React, { useState, useEffect } from 'react';
import * as Styles from './CounterOffer.styles';

const CounterOffer = ({ element }) => {
  const dueDate = element.due_date;
  const [timeLeft, setTimeLeft] = useState('');

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const actualDate = formatDate(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      const totalSeconds = Math.floor((new Date(dueDate) - new Date()) / 1000);
      const days = Math.floor(totalSeconds / (3600 * 24));
      const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const distance = `${days}, ${hours}, ${minutes}, ${seconds}`;
      setTimeLeft(distance);
    }, 100);

    return () => clearInterval(interval);
  }, [dueDate]);


  return (
    <Styles.WrapperCounter>
      {(actualDate !== dueDate && actualDate < dueDate) && (
        <>
          <Styles.Title>
            Oferta expira em:
          </Styles.Title>
          <Styles.CounterBoxes>
            <Styles.TimeBox>
              {timeLeft.split(', ')[0]}
            </Styles.TimeBox>
            <Styles.Label>dia</Styles.Label>
          </Styles.CounterBoxes>

          <Styles.Separator>:</Styles.Separator>

          <Styles.CounterBoxes>
            <Styles.TimeBox>
              {timeLeft.split(', ')[1]}
            </Styles.TimeBox>
            <Styles.Label>hr</Styles.Label>
          </Styles.CounterBoxes>

          <Styles.Separator>:</Styles.Separator>

          <Styles.CounterBoxes>
            <Styles.TimeBox>
              {timeLeft.split(', ')[2]}
            </Styles.TimeBox>
            <Styles.Label>min</Styles.Label>
          </Styles.CounterBoxes>

          <Styles.Separator>:</Styles.Separator>

          <Styles.CounterBoxes>
            <Styles.TimeBox>
              {timeLeft.split(', ')[3]}
            </Styles.TimeBox>
            <Styles.Label>seg</Styles.Label>
          </Styles.CounterBoxes>
        </>
      )}
    </Styles.WrapperCounter>
  );
};

export default CounterOffer;
